import Section from '~/constants/vdp/section';
import useIsInWhyBuyImageryExperiment from '~/hooks/vdp/useIsInWhyBuyImageryExperiment';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';
import ControlWhyBuy from './ControlWhyBuy';
import ExperimentWhyBuy from './ExperimentWhyBuy';

const WhyBuy = () => {
  const isInWhyBuyImageryExperiment = useIsInWhyBuyImageryExperiment();

  return isInWhyBuyImageryExperiment ? <ExperimentWhyBuy /> : <ControlWhyBuy />;
};

export default withErrorBoundary(WhyBuy, { section: Section.WhyBuy });
